(function() {
  'use strict';
  
  // Initialize all send hint modals on the page
  function initSendHintModals() {
    const modals = document.querySelectorAll('[id^="send-hint-modal-"]');
    
    modals.forEach(function(modal) {
      const sectionId = modal.id.replace('send-hint-modal-', '');
      const modalId = 'send-hint-modal-' + sectionId;
      const formId = 'send-hint-form-' + sectionId;
      const modalOpenerSelector = 'modal-opener[data-modal="' + modalId + '"]';
      
      // Skip if already initialized
      if (modal.dataset.initialized === 'true') return;
      modal.dataset.initialized = 'true';
      
      const modalOpener = document.querySelector(modalOpenerSelector);
      const form = document.getElementById(formId);
      
      if (!modalOpener || !modal || !form) {
        return;
      }
      
      const closeButton = modal.querySelector('.hint-popup-close');
      
      // Close modal function
      function closeModal() {
        try {
          if (!modal.classList.contains('hint-popup-open')) return; // Already closed
          
          modal.classList.remove('hint-popup-open');
          
          // Remove any classes we added
          document.body.classList.remove('hint-popup-body-lock');
          document.documentElement.classList.remove('hint-popup-body-lock');
          
          // Restore scrolling - use multiple approaches to ensure it works
          setTimeout(function() {
            try {
              // Approach 1: Remove inline styles we added
              const bodyOverflow = document.body.style.getPropertyValue('overflow');
              const htmlOverflow = document.documentElement.style.getPropertyValue('overflow');
              
              if (bodyOverflow === 'hidden') {
                document.body.style.removeProperty('overflow');
              }
              if (htmlOverflow === 'hidden') {
                document.documentElement.style.removeProperty('overflow');
              }
              
              // Approach 2: Force set to auto if still hidden
              const computedBodyOverflow = window.getComputedStyle(document.body).overflow;
              const computedHtmlOverflow = window.getComputedStyle(document.documentElement).overflow;
              
              if (computedBodyOverflow === 'hidden') {
                document.body.style.overflow = 'auto';
                // Remove after a moment to let natural styles take over
                setTimeout(function() {
                  document.body.style.removeProperty('overflow');
                }, 50);
              }
              if (computedHtmlOverflow === 'hidden') {
                document.documentElement.style.overflow = 'auto';
                setTimeout(function() {
                  document.documentElement.style.removeProperty('overflow');
                }, 50);
              }
              
              // Approach 3: Remove position if we set it
              if (document.body.style.getPropertyValue('position') === 'fixed') {
                document.body.style.removeProperty('position');
              }
              if (document.documentElement.style.getPropertyValue('position') === 'fixed') {
                document.documentElement.style.removeProperty('position');
              }
            } catch (err) {
              console.error('Error restoring scroll:', err);
              // Final fallback
              document.body.style.overflow = '';
              document.documentElement.style.overflow = '';
            }
          }, 50);
          
          form.reset();
          const errorDiv = form.querySelector('.js-form-error');
          const successDiv = form.querySelector('.js-form-success');
          if (errorDiv) {
            errorDiv.hidden = true;
            errorDiv.textContent = '';
          }
          if (successDiv) {
            successDiv.hidden = true;
            successDiv.textContent = '';
          }
        } catch (err) {
          console.error('Error closing modal:', err);
          modal.classList.remove('hint-popup-open');
          document.body.classList.remove('hint-popup-body-lock');
          document.documentElement.classList.remove('hint-popup-body-lock');
        }
      }
      
      // Function to open modal
      function openModal() {
        if (!modal) return;
        
        // Open modal
        modal.classList.add('hint-popup-open');
        // Store current scroll position
        const scrollY = window.scrollY;
        // Use class-based approach instead of inline styles with !important
        document.body.classList.add('hint-popup-body-lock');
        document.documentElement.classList.add('hint-popup-body-lock');
        // Set overflow without !important to allow easier removal
        if (!document.body.style.overflow || document.body.style.overflow === '') {
          document.body.style.overflow = 'hidden';
        }
        if (!document.documentElement.style.overflow || document.documentElement.style.overflow === '') {
          document.documentElement.style.overflow = 'hidden';
        }
        // Restore scroll position to prevent jump
        window.scrollTo(0, scrollY);
        // Focus first input
        const firstInput = form.querySelector('input[type="email"]');
        if (firstInput) {
          setTimeout(() => firstInput.focus(), 100);
        }
      }
      
      // Handle modal opening - listen for clicks on modal-opener or its button
      const button = modalOpener.querySelector('button');
      if (button) {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          openModal();
        }, true); // Use capture phase to ensure we catch it first
      }
      
      // Also handle clicks directly on modal-opener (in case theme handles it)
      modalOpener.addEventListener('click', function(e) {
        // Only handle if clicking on the modal-opener itself, not its children
        if (e.target === modalOpener) {
          e.preventDefault();
          e.stopPropagation();
          openModal();
        }
      }, true);
      
      // Fallback: Listen for any clicks that might open the modal
      // This handles cases where the theme's modal-opener component might be doing something
      document.addEventListener('click', function(e) {
        const clickedOpener = e.target.closest('modal-opener[data-modal="' + modalId + '"]');
        if (clickedOpener && clickedOpener === modalOpener) {
          // Small delay to let theme's handler run first, then override if needed
          setTimeout(function() {
            if (!modal.classList.contains('hint-popup-open')) {
              openModal();
            }
          }, 10);
        }
      });
      
      // Close button
      if (closeButton) {
        closeButton.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          closeModal();
        });
      }
      
      // Close on backdrop click
      modal.addEventListener('click', function(e) {
        if (e.target === modal || (e.target.classList.contains('hint-popup-container') && e.target !== modal.querySelector('.hint-popup-content'))) {
          e.preventDefault();
          e.stopPropagation();
          closeModal();
        }
      });
      
      // Close on Escape key
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && modal.classList.contains('hint-popup-open')) {
          closeModal();
        }
      });
      
      // Handle form submission
      form.addEventListener('submit', async function(e) {
        e.preventDefault();
        
        const submitButton = form.querySelector('button[type="submit"]');
        const errorDiv = form.querySelector('.js-form-error');
        const successDiv = form.querySelector('.js-form-success');
        const senderInput = form.querySelector('input[name="sender"]');
        const sender = senderInput ? senderInput.value.trim() : '';
        const email = form.querySelector('input[name="email"]').value;
        const message = form.querySelector('textarea[name="message"]').value;
        const productUrl = form.dataset.productUrl;
          const rawTitle = form.dataset.productTitle || '';
        const productTitle = rawTitle.replace(/\b\w/g, function(c) { return c.toUpperCase(); });
        let productImage = (form.dataset.productImage || '').trim();
        if (productImage && productImage.indexOf('//') === 0) {
          productImage = 'https:' + productImage;
        }
        // Hide previous messages
        if (errorDiv) {
          errorDiv.hidden = true;
          errorDiv.textContent = '';
        }
        if (successDiv) {
          successDiv.hidden = true;
          successDiv.textContent = '';
        }
        
        // Disable submit button
        if (submitButton) {
          submitButton.disabled = true;
          submitButton.textContent = 'Sending...';
        }
        
        try {
          // Build email content
          const productLink = window.location.origin + productUrl;
          let emailBody = 'Someone sent you a hint about: ' + productTitle + '\n\n';
          emailBody += 'Product link: ' + productLink + '\n\n';
          
          if (message && message.trim()) {
            emailBody += 'Message:\n' + message + '\n\n';
          }
          
          emailBody += '---\n';
          emailBody += 'This hint was sent from your Shopify store.';
          
          // Use EmailJS to send email (configured in emailjs-config.js)
          // Check if EmailJS is configured and available
          if (typeof window.EmailJSHelper !== 'undefined' && window.EmailJSHelper.isConfigured()) {
            // Send email using EmailJS helper
            await window.EmailJSHelper.sendHintEmail({
              toEmail: email,
              senderEmail: sender || '',
              productTitle: productTitle,
              productLink: productLink,
              productImage: productImage,
              message: message || '',
              fromStore: window.location.hostname
            });
          } else {
            // OPTION 2: Fallback to Shopify contact form (sends to store owner)
            // This sends a notification to the store owner with the hint recipient's email
            // Note: To send directly to the recipient, you must configure EmailJS above
            const formData = new FormData();
            formData.append('form_type', 'contact');
            formData.append('utf8', '✓');
            formData.append('contact[email]', email);
            formData.append('contact[body]', 'Hint recipient: ' + email + '\n\n' + emailBody);
            
            const response = await fetch('/contact', {
              method: 'POST',
              body: formData
            });
            
            if (!response.ok) {
              throw new Error('Failed to send hint');
            }
          }
          
          // Show success message
          if (successDiv) {
            successDiv.hidden = false;
            successDiv.textContent = 'Hint sent successfully!';
            successDiv.style.color = 'green';
          }
          
          // Reset form
          form.reset();
          
          // Close modal after 2 seconds
          setTimeout(() => {
            closeModal();
            if (successDiv) {
              successDiv.hidden = true;
            }
          }, 2000);
        } catch (error) {
          console.error('Error sending hint:', error);
          if (errorDiv) {
            errorDiv.hidden = false;
            errorDiv.textContent = 'Failed to send hint. Please try again.';
            errorDiv.style.color = 'red';
          }
        } finally {
          // Re-enable submit button
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.textContent = 'Send Hint';
          }
        }
      });
    });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSendHintModals);
  } else {
    initSendHintModals();
  }
  
  // Re-initialize in theme editor
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initSendHintModals);
  }
})();

